import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { withRouter, browserHistory } from 'react-router';
import queryString from 'stringquery';
import { ToastContainer, Flip } from 'react-toastify';
import {loadReCaptcha} from 'react-recaptcha-v3'

import * as loginActions from '../Actions/login';


import { Header, Footer } from './Layout';

class App extends Component {

  async componentDidMount() {

    const qString = queryString(this.props.location.search);

    if (qString.aut === '' || typeof(qString.aut) === 'undefined') {

      if (!localStorage.getItem("boleto@dataUser")) {
        if (!this.props.login.isLoginSuccess)
          browserHistory.push('/login');
      }
      else {
        const user = localStorage.getItem("boleto@dataUser");
        await this.props.stayLogged(user);
      }
    }
    else {
      await this.props.doLogin('', '', this.props.login.token, true, qString.aut);


    }

    // if (localStorage.getItem(`boleto@cart${this.props.login.user.CGCCPF}`)) {
    //   // const cart = localStorage.getItem(`boleto@cart${this.props.login.user.CGCCPF}`);
    //   // await this.props.setCart(JSON.parse(cart));
    // }

    // ReCaptcha
    let CaptchaPKey = "6LeQHZQUAAAAADuA19nl5ffz7Eo6J_IvrtnvKHkO";
    loadReCaptcha(CaptchaPKey)
  }

  changeMenu(){
    this.state.menuClass === '' ?
      this.setState({menuClass : 'active'})
    :
      this.setState({menuClass : ''});
  }

  render() {
    return (
      <div className="App">
        <Header />


        <div className="section">
          <div className="container">
            <div className="row">
              {this.props.children}
            </div>
          </div>
        </div>
        <Footer />

        <ToastContainer
          position="top-center"
          autoClose={ 3000 } //3 segundos
          hideProgressBar={ true }
          transition={ Flip }
        />

      </div>
    );
  }
}

const mapStateToProps = state => ({ login: state.login });
const mapDispatchToProps = dispatch => bindActionCreators({ ...loginActions }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/Components/App.js